<p>dlg-edit-validation-state works!</p>
